import PrintJob from '../../../../../types/api/print-job'
import PrintJobExecutor from '../../../../../types/api/print-job-executor'
import { JobStatuses } from '../../../../../types/api/print-job'
import PrintQueueEntry from '../../../../../types/api/print-queue-entry'

export function getActiveExecutor(printJob?: PrintJob): PrintJobExecutor | undefined {
    return printJob?.print_job_executors?.find(executor => !executor.end)
}

export function hasActiveExecutor(printJob?: PrintJob): boolean {
    return !!getActiveExecutor(printJob)
}

export function isPrintJobPaused(printJob?: PrintJob): boolean {
    if (printJob?.jobStatus !== JobStatuses.Printing) return false
    if (printJob.print_job_executors === undefined) return false
    return !hasActiveExecutor(printJob)
}

export function isPrintJobCancelled(printJob?: PrintJob): boolean {
    return printJob?.jobStatus === JobStatuses.Cancelled
}

export function getPrintQueueEntryRowClassName(record: PrintQueueEntry): string {
    const printJob = record.print_job
    if (isPrintJobCancelled(printJob)) return 'print-job-cancelled'
    if (isPrintJobPaused(printJob)) return 'print-job-paused'
    if (isPrintJobInProgress(printJob)) return 'print-job-printing'
    return ''
}

export function isPrintJobActive(printJob?: PrintJob): boolean {
    return printJob?.jobStatus === JobStatuses.Printing && hasActiveExecutor(printJob)
}

export function isPrintJobInProgress(printJob?: PrintJob): boolean {
    return printJob?.jobStatus === JobStatuses.Printing
}

export function getCurrentUserActiveExecutor(
    printJob?: PrintJob,
    userDocumentId?: string
): PrintJobExecutor | undefined {
    if (!userDocumentId) return undefined

    return printJob?.print_job_executors?.find(
        executor => executor.user.documentId === userDocumentId && !executor.end
    )
}

export function isCurrentUserActiveExecutor(printJob?: PrintJob, userDocumentId?: string): boolean {
    return !!getCurrentUserActiveExecutor(printJob, userDocumentId)
}
